"use client";

/**
 * Shared chrome for every embedded activity. Each type gets its own hue (set
 * via the `activity--{type}` class in globals.css) so flashcards, matching,
 * and knowledge checks read as distinct — while the frame, gradient header,
 * and rounded shell keep them a coherent family that tracks the lesson theme.
 */

import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export default function ActivityFrame({
  type,
  kindLabel,
  icon: Icon,
  title,
  meta,
  children,
}: {
  type: "flashcards" | "matching" | "knowledge_check" | "sequencing" | "timeline" | "step_reveal";
  kindLabel: string;
  icon: LucideIcon;
  title: string;
  meta?: ReactNode;
  children: ReactNode;
}) {
  return (
    // Selection-highlighting is disabled inside activities: stateful UI, no
    // stable text anchor, and quotes could copy answer text into notes
    <div className={`activity activity--${type} not-prose my-5`} data-annotate="off">
      <div className="activity__head">
        <span className="activity__chip">
          <Icon className="h-4 w-4" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="activity__kind">{kindLabel}</span>
          <span className="activity__title">{title}</span>
        </span>
        {meta && <span className="activity__meta">{meta}</span>}
      </div>
      <div className="activity__body">{children}</div>
    </div>
  );
}
